import styled from 'styled-components';

export const Container = styled.div`
  padding: 1rem;
`;

export const TableSearchRegistrations = styled.form`
  display: flex;
  gap: 1rem;
  align-items: flex-end;
`; 